import { action } from '@ember/object';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class NotificationService extends Service {
  @tracked statusFeature = true;
  @tracked sourceFeature = true;

  @tracked showNotification = false;
  @tracked notificationMessage = '';
  /** `'success'` (green check) or `'error'` (red alert). */
  @tracked notificationType = 'success';

  notificationTimeout = null;

  constructor() {
    super(...arguments);
    this.setStatusFeatureViewed();
    this.setSourceFeatureViewed();
  }

  setStatusFeatureViewed() {
    const showFeature = window.localStorage.getItem('statusFeature');
    if (showFeature === 'false') this.statusFeature = false;
    else this.statusFeature = true;
  }

  setSourceFeatureViewed() {
    const showFeature = window.localStorage.getItem('sourceFeature');
    if (showFeature === 'false') this.sourceFeature = false;
    else this.sourceFeature = true;
  }

  @action
  setFeatureAsViewed(key) {
    this[key] = false;
    window.localStorage.setItem(key, false);
  }

  @action
  toggleShowNotification(message = undefined, type = 'success') {
    clearTimeout(this.notificationTimeout);
    this.showNotification = !this.showNotification;
    if (this.showNotification === true) {
      if (message) this.notificationMessage = message;
      this.notificationType = type;

      this.notificationTimeout = setTimeout(() => {
        this.toggleShowNotification();
        this.notificationMessage = '';
      }, 5000);
    }
  }
}
